/**
 * Build additionalFields for save: keep existing keys not on this form, overlay form values.
 * Form fields use the `*-additionalDochubField` suffix convention.
 */
export const buildMergedAdditionalFields = (submittedForm = {}, existingAdditionalFields) => {
  const fromForm = Object.keys(submittedForm)
    .filter(k => k.endsWith('-additionalDochubField'))
    .reduce(
      (acc, key) => ({
        ...acc,
        [key.replace('-additionalDochubField', '')]: submittedForm[key]
      }),
      {}
    );

  const existing =
    existingAdditionalFields && typeof existingAdditionalFields === 'object' && !Array.isArray(existingAdditionalFields)
      ? existingAdditionalFields
      : {};

  return { ...existing, ...fromForm };
};

/**
 * Build customEntities for save: { [entityDefinitionId]: entityRecordId }.
 * Form fields use the `*-customEntityField` suffix convention.
 */
export const buildMergedCustomEntities = (submittedForm = {}, existingCustomEntities) => {
  const fromForm = Object.keys(submittedForm)
    .filter(k => k.endsWith('-customEntityField'))
    .reduce((acc, key) => {
      const entityId = key.replace('-customEntityField', '');
      const value = submittedForm[key];
      acc[entityId] = value === undefined || value === null ? '' : value;
      delete submittedForm[key];
      return acc;
    }, {});

  const existing =
    existingCustomEntities && typeof existingCustomEntities === 'object' && !Array.isArray(existingCustomEntities)
      ? existingCustomEntities
      : {};

  return { ...existing, ...fromForm };
};
